module.exports = __webpack_public_path__ + "static/full05-3df072cc8eadd4530003a6651d2ae98d.png";